import editionLayout from '@views/activity/editionActivity/nav/index.vue';
// import handpick from '@views/activity/editionActivity/handpick/index.vue';
const activityRoutes = [
  {
    path: '/gp/editionActivity',
    name: 'editionActivity',
    component: editionLayout,
    children: [
      {
        path: 'edition-handpick',
        name: 'ativity-edition-handpick',
        meta: {
          pageType: 'ativity-edition-handpick',
          pageName: '爆料精选',
          keepAlive: true,
          sideBar: 'select',
          type: 1,
        },
        component: () => import(/* webpackChunkName: "ativity-handpick" */'@views/activity/editionActivity/handpick/index.vue'),
      },
      {
        path: 'edition',
        name: 'activity-edition',
        meta: {
          pageType: 'ativity-edition',
          pageName: '爆料站',
          keepAlive: true,
          sideBar: 'select',
        },
        component: () => import(/* webpackChunkName: "ativity-edition" */'@views/walkthrough/versionInfo/report/index.vue'),
      },

      {
        path: 'edition-feature',
        name: 'ativity-edition-feature',
        meta: {
          pageType: 'ativity-edition-feature',
          pageName: '专题站',
          keepAlive: true,
          sideBar: 'edition',
          type: 4,
        },
        component: () => import(/* webpackChunkName: "ativity-edition-feature" */'@views/walkthrough/versionInfo/feature/index.vue'),
      },
      {
        path: 'edition-vote',
        name: 'ativity-edition-vote',
        meta: {
          pageType: 'ativity-edition-vote',
          pageName: '话题站',
          keepAlive: true,
          sideBar: 'activity',
          type: 3,
        },
        component: () => import(/* webpackChunkName: "ativity-edition-vote" */'@views/walkthrough/versionInfo/vote/index.vue'),
      },
      {
        path: 'edition-news',
        name: 'ativity-edition-news',
        meta: {
          pageType: 'ativity-edition-news',
          pageName: '任务站',
          keepAlive: true,
          sideBar: 'activity',
        },
        component: () => import(/* webpackChunkName: "ativity-edition-news" */'@views/walkthrough/versionInfo/news/index.vue'),
      },
      {
        path: 'edition-strategy',
        name: 'ativity-edition-strategy',
        meta: {
          pageType: 'ativity-edition-strategy',
          pageName: '相关攻略',
          keepAlive: true,
          sideBar: 'strategy',
          type: 2,
        },
        component: () => import(/* webpackChunkName: "ativity-edition-strategy" */'@views/walkthrough/versionInfo/strategy/index.vue'),
      },
      {
        path: 'edition-short',
        name: 'ativity-edition-short',
        meta: {
          pageType: 'ativity-edition-short',
          pageName: '短攻略',
          keepAlive: true,
          sideBar: 'strategy',
          type: 2,
        },
        component: () => import(/* webpackChunkName: "ativity-edition-short" */'@views/walkthrough/versionInfo/short/index.vue'),
      },
    ],
  },
  // {
  //   path: '/gp/edition-version',
  //   name: 'ativity-edition-version',
  //   meta: {
  //     pageType: 'ativity-edition-version',
  //     pageName: '拍脸大事件',
  //     keepAlive: true,
  //   },
  //   component: () => import('@views/walkthrough/versionInfo/newVersion/index.vue'),
  // },
];

export default activityRoutes;
